export const convertStringFormatToMs = (timeString: string): number => {
  let milliseconds = 0

  const [value, unitType] = timeString.split(/(?<=[0-9])(?=[a-z])/)
  const numericValue = parseInt(value)

  switch (unitType) {
    case 'ms':
      milliseconds += numericValue
      break
    case 's':
      milliseconds += numericValue * 1000
      break
    case 'm':
      milliseconds += numericValue * 1000 * 60
      break
    case 'h':
      milliseconds += numericValue * 1000 * 60 * 60
      break
    default:
      throw new Error(`Unité de temps invalide : ${unitType}`)
  }

  return milliseconds
}
